import { DashboardCard } from "@dashboard/components/Card";
import SummaryLine from "@dashboard/orders/components/OrderSummaryCard/SummaryLine";
import { SummaryList } from "@dashboard/orders/components/OrderSummaryCard/SummaryList";
import React from "react";
import { useIntl } from "react-intl";

import { paymentRecoveryMessages } from "../../messages";
import { PaymentRecoveryCheckoutDetails } from "../../utils";

interface PaymentRecoveryOrderSummaryProps {
  checkout: PaymentRecoveryCheckoutDetails;
}

/**
 * A checkout-flavored fork of OrderSummaryCard
 * (src/orders/components/OrderSummaryCard) -- same SummaryLine/SummaryList
 * primitives and layout, reading checkout's own subtotal/shipping/tax/total
 * fields instead of an Order's (no discounts/gift-card lines here, since a
 * checkout doesn't carry that history the way a completed order would).
 */
export const PaymentRecoveryOrderSummary = ({ checkout }: PaymentRecoveryOrderSummaryProps) => {
  const intl = useIntl();

  return (
    <DashboardCard data-test-id="payment-recovery-order-summary">
      <DashboardCard.Header>
        <DashboardCard.Title>
          {intl.formatMessage(paymentRecoveryMessages.orderSummarySection)}
        </DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        <SummaryList>
          <SummaryLine
            text={intl.formatMessage(paymentRecoveryMessages.subtotal)}
            money={checkout.subtotalPrice.net}
          />
          <SummaryLine
            text={intl.formatMessage(paymentRecoveryMessages.shipping)}
            money={checkout.shippingPrice.net}
          />
          <SummaryLine
            text={intl.formatMessage(paymentRecoveryMessages.taxes)}
            money={checkout.totalPrice.tax}
          />
          <SummaryLine
            bold
            text={intl.formatMessage(paymentRecoveryMessages.total)}
            money={checkout.totalPrice.gross}
          />
        </SummaryList>
      </DashboardCard.Content>
    </DashboardCard>
  );
};

PaymentRecoveryOrderSummary.displayName = "PaymentRecoveryOrderSummary";
export default PaymentRecoveryOrderSummary;
